import { Dispatch } from 'redux';
import { get } from '@chat/utils';
import { BASE_CONFIG, MyThunkResult } from '@/typings/reducer';
import {
    INDEX_TYPE,
    IndexSetBaseConfigAction,
    IndexSetFormTipAction,
    IndexSetLoadingAction,
    IndexSetUserInfoAction,
    IndexSetOrientationAction,
    IndexSetDifyLogWorkflowRunIdAction
} from './actionType';
import { IM_USER_INFO } from '@/typings/global';
import { FORM_TOKEN } from '@/api/url';

/**
 * 设置loading状态
 * @param {*} bol
 */
export const setloading =
    (bol: boolean): MyThunkResult<unknown, IndexSetLoadingAction> =>
    (dispatch: Dispatch<IndexSetLoadingAction>) => {
        dispatch({
            type: INDEX_TYPE.SET_LOADING_STATUS,
            payload: bol
        });
    };

/**
 * 基础配置注入
 */
export const setbaseconfig =
    (config: BASE_CONFIG): MyThunkResult<unknown, IndexSetBaseConfigAction> =>
    (dispatch: Dispatch<IndexSetBaseConfigAction>) => {
        dispatch({
            type: INDEX_TYPE.SET_BASE_CONFIG,
            payload: config
        });
    };

/**
 * 设置用户信息
 */
export const setuserinfo =
    (userInfo: IM_USER_INFO): MyThunkResult<unknown, IndexSetUserInfoAction> =>
    (dispatch: Dispatch<IndexSetUserInfoAction>) => {
        dispatch({
            type: INDEX_TYPE.SET_USER_INFO,
            payload: userInfo
        });
    };

/**
 * 获取表单链接
 */
export const getformtoken =
    ({ refer, type = '' }: { refer: 1 | 2; type? }): MyThunkResult<unknown, unknown> =>
    (dispatch, getState) =>
        new Promise((resolve, reject) => {
            const { base_config } = getState().IndexReducer;
            const dat = {
                platform: base_config.game.platform,
                game_id: base_config.game.id,
                type,
                refer
            };
            get(FORM_TOKEN, dat)
                .then((res) => {
                    return resolve(res.data.d);
                })
                .catch((err) => {
                    IM.IMServer.notice('error', err?.data?.e || err);
                    return reject(err);
                });
        });

/**
 * 设置工单未读提示
 */
export const setformtip =
    (tip: number): MyThunkResult<unknown, IndexSetFormTipAction> =>
    (dispatch: Dispatch<IndexSetFormTipAction>) => {
        dispatch({
            type: INDEX_TYPE.SET_FORM_TIP,
            payload: tip
        });
    };
export const setorientation =
    (orientation: string): MyThunkResult<unknown, IndexSetOrientationAction> =>
    (dispatch: Dispatch<IndexSetOrientationAction>) => {
        dispatch({
            type: INDEX_TYPE.SET_ORIENTATION,
            payload: orientation
        });
    };

export const setDifyLogWorkflowRunId =
    (workflowRunId: string): MyThunkResult<unknown, IndexSetDifyLogWorkflowRunIdAction> =>
    (dispatch: Dispatch<IndexSetDifyLogWorkflowRunIdAction>) => {
        dispatch({
            type: INDEX_TYPE.SET_DIFY_LOG_WORKFLOW_RUN_ID,
            payload: workflowRunId
        });
    };
